<div class="modal inmodal fade in parcel-modal create-modal" [ngClass]="{'show': showModal}">
    <div class="modal-dialog ">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title col-sm-8">Schedule</h4>
                <div class="input-group-btn pull-right">
                    <button tabindex="-1"
                            class="btn btn-primary submit"
                            (click)="clickSubmit()"
                            type="submit"
                            [disabled]="disabledSubmit || settingsAmenitiesService.modalSpinnerShow">
                        Save
                    </button>
                    <button data-toggle="dropdown"
                            class="btn btn-primary dropdown-toggle"
                            type="button"
                            aria-expanded="false">
                        <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu pull-right" style="z-index: 1001;">
                        <li><a (click)="hideModal()">Cancel</a></li>
                    </ul>
                </div>
            </div>
            <div class="modal-body">
                <div class="col-md-5" style="height: 402px;">
                    <form #form="ngForm"
                          (ngSubmit)="onSubmit(form)"
                          [ngClass]="{'ng-submitted': form.submitted}"
                          autocomplete="off">
                        <!-- ___ Booking Type ___ -->
                        <div class="row m-b-sm">
                            <div class="col-md-5">
                                <label>Booking Type</label>
                            </div>
                            <div class="col-md-7">
                                <select [ngModel]="data.timeSequenceType"
                                        (change)="onTimeSequenceChange($event)"
                                        class="form-control"
                                        name="timeSequenceType"
                                        #timeSequenceType>
                                    <option value="" hidden></option>
                                    <option value="daily">Daily</option>
                                    <option value="hourly">Hourly</option>
                                    <option value="range">Time Range</option>
                                </select>
                            </div>
                        </div>

                        <!--___ Template ___ -->
                        <div class="row m-b-sm">
                            <div class="col-md-5">
                                <label>Template</label>
                            </div>
                            <div class="col-md-7">
                                <select class="form-control"
                                        name="uses"
                                        [ngModel]="data.template"
                                        (ngModelChange)="setAmenityFromTemplate($event)">
                                    <option value="" hidden></option>
                                    <option *ngFor="let template of amenityTemplates" [value]="template.name">
                                        {{template.name}}
                                    </option>
                                    <option value="other">Other</option>
                                </select>
                                <spinner [spinnerShow]="amenityTemplatesLoadingSpinner"></spinner>
                            </div>
                        </div>

                        <!-- ___ Save as Template  ___ -->
                        <div class="row m-b-sm">
                            <div class="col-md-5"></div>
                            <div class="col-md-7">
                                <label class="img-checkbox">
                                    <input id="saveAsTemplate"
                                           type="checkbox"
                                           name="saveAsTemplate"
                                           [(ngModel)]="data.saveAsTemplate">
                                    <label for="saveAsTemplate">
                                        <svg-checked></svg-checked>
                                    </label>
                                    <span>Save as Template</span>
                                </label>
                            </div>
                        </div>

                        <div class="row m-b-sm">
                            <div class="col-md-5"></div>
                            <div class="col-md-7 fourteenPixelText">
                                <input class="form-control"
                                       maxlength="50"
                                       name="name"
                                       placeholder="Enter Template Name"
                                       [(ngModel)]="data.templateName">
                            </div>
                        </div>

                        <div class="row m-b-sm" *ngIf="form.value.timeSequenceType === 'range'">
                            <div class="col-md-5">
                                <label>Minutes step</label>
                            </div>
                            <div class="col-md-7">
                                <select [ngModel]="data.minutesStep"
                                        (ngModelChange)="onMinutesStepChange($event, minutesStep)"
                                        #minutesStep
                                        name="minutesStep"
                                        class="form-control">
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="15">15</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                </select>
                            </div>
                            <div class="error" *ngIf="isMinutesStepError">The smaller step is already in use in the
                                schedule. Please use another step
                            </div>
                        </div>

                        <div class="row m-b-sm" *ngIf="form.value.timeSequenceType == 'daily'">
                            <div class="col-md-9 padding-right-none">
                                <label>Max # of Days Allowed Per Booking</label>
                            </div>
                            <div class="col-md-3 fourteenPixelText padding-none">
                                <input class="max-number-small-input"
                                       name="bookingMaxDay"
                                       [(ngModel)]="data.bookingMaxDay">
                            </div>
                        </div>

                        <div class="row m-b-sm" *ngIf="form.value.timeSequenceType == 'hourly'">
                            <div class="col-md-9 padding-right-none">
                                <label>Min # of Hours Allowed Per Booking</label>
                            </div>
                            <div class="col-md-3 fourteenPixelText padding-none">
                                <input class="max-number-small-input"
                                       name="bookingMinHour"
                                       [(ngModel)]="data.bookingMinHour">
                            </div>
                        </div>

                        <div class="row m-b-sm" *ngIf="form.value.timeSequenceType == 'hourly'">
                            <div class="col-md-9 padding-right-none">
                                <label>Max # of Hours Allowed Per Booking</label>
                            </div>
                            <div class="col-md-3 fourteenPixelText padding-none">
                                <input class="max-number-small-input"
                                       name="bookingMaxHour"
                                       [(ngModel)]="data.bookingMaxHour">
                            </div>
                        </div>

                        <!-- ___ Check-Out Time  ___ -->
                        <div class="row m-b-sm check-in-out-time" *ngIf="form.value.timeSequenceType == 'daily'">
                            <div class="col-md-5">
                                <label>Check-Out Time</label>
                            </div>
                            <div class="col-md-7">
                                <select class="form-control"
                                        name="checkoutHours"
                                        [(ngModel)]="checkOutTime.hours"
                                        required
                                        (change)="checkOutTime.minutes = checkOutTime.minutes ? checkOutTime.minutes : '00'">
                                    <option value="" hidden></option>
                                    <option *ngFor="let hour of hoursArray" [value]="hour">{{hour}}</option>
                                </select>
                                <select class="form-control" name="checkoutMinutes" [(ngModel)]="checkOutTime.minutes"
                                        required>
                                    <option value="" hidden></option>
                                    <option *ngFor="let minutes of minutesArray" [value]="minutes">{{minutes}}</option>
                                </select>
                                <select class="form-control" name="checkoutAmPm" [(ngModel)]="checkOutTime.amPM"
                                        required>
                                    <option value="" hidden></option>
                                    <option [value]="'AM'">AM</option>
                                    <option [value]="'PM'">PM</option>
                                </select>
                            </div>
                        </div>

                        <!-- ___ Check-In Time  ___ -->
                        <div class="row m-b-sm check-in-out-time" *ngIf="form.value.timeSequenceType == 'daily'">
                            <div class="col-md-5">
                                <label>Check-In Time</label>
                            </div>
                            <div class="col-md-7">
                                <select class="form-control"
                                        name="checkinHours"
                                        [(ngModel)]="checkInTime.hours"
                                        required
                                        (change)="checkInTime.minutes = checkInTime.minutes ? checkInTime.minutes : '00'">
                                    <option value="" hidden></option>
                                    <option *ngFor="let hour of hoursArray" [value]="hour">{{hour}}</option>
                                </select>
                                <select class="form-control" name="checkinMinutes" [(ngModel)]="checkInTime.minutes"
                                        required>
                                    <option value="" hidden></option>
                                    <option *ngFor="let minutes of minutesArray" [value]="minutes">{{minutes}}</option>
                                </select>
                                <select class="form-control" name="checkinAmPm" [(ngModel)]="checkInTime.amPM" required>
                                    <option value="" hidden></option>
                                    <option [value]="'AM'">AM</option>
                                    <option [value]="'PM'">PM</option>
                                </select>
                            </div>
                        </div>

                        <div class="row text-center space-30" hidden>
                            <button type="submit"
                                    id="submitButton"
                                    #submitButton
                                    class="btn btn-primary submit-btn"
                                    [disabled]="disabledSubmit">
                                Save
                            </button>
                        </div>
                    </form>
                </div>
                <div class="col-md-7 days-section">
                    <div class="bookable-header">
                        Bookable
                        <span *ngIf="form.value.timeSequenceType == 'daily'">Days</span>
                        <span *ngIf="form.value.timeSequenceType == 'hourly'">Hours</span>
                        <span *ngIf="form.value.timeSequenceType == 'range'">Ranges</span>
                    </div>
                    <div class="row bookable-column">
                        <div class="img-checkbox">
                            <input id="mondayCheckbox"
                                   type="checkbox"
                                   name="mondayCheckbox"
                                   #mondayCheckbox
                                   (change)="onDayCheckboxValueChange('mondayCheckbox', 1)">
                            <label for="mondayCheckbox">
                                <svg-checked></svg-checked>
                            </label>
                            <span>Monday</span>
                        </div>
                        <ng-template [ngTemplateOutlet]="copyButtons"
                                     [ngTemplateOutletContext]="{currentIndex: 1}"></ng-template>
                        <div class="hourly-range-times"
                             *ngIf="form.value.timeSequenceType && (form.value.timeSequenceType == 'hourly'
                                    || form.value.timeSequenceType == 'range') && checkboxIsChecked('mondayCheckbox')">
                            <div *ngIf="weekDays.length && getDayIndexInWeekDaysArray(1) != -1">
                                <div
                                    *ngFor="let dayHour of weekDays[getDayIndexInWeekDaysArray(1)].dayHours; let index = index;"
                                    style="display: inline-flex;">
                                    <ng-template [ngTemplateOutlet]="fromDayColumn"
                                                 [ngTemplateOutletContext]="{dayHour: dayHour}"></ng-template>
                                    <ng-template [ngTemplateOutlet]="toDayColumn"
                                                 [ngTemplateOutletContext]="{dayHour: dayHour}"></ng-template>
                                    <div class="action-block">
                                        <i class="fa fa-plus" (click)="addTimeSlot('monday', 1, index)"></i>
                                        <i class="fa fa-trash"
                                           (click)="deleteTimeSlot(1, index)"
                                           *ngIf="weekDays[getDayIndexInWeekDaysArray(1)].dayHours.length > 1"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row bookable-column">
                        <div class="img-checkbox">
                            <input id="tuesdayCheckbox"
                                   type="checkbox"
                                   name="tuesdayCheckbox"
                                   #tuesdayCheckbox
                                   (change)="onDayCheckboxValueChange('tuesdayCheckbox', 2)">
                            <label for="tuesdayCheckbox">
                                <svg-checked></svg-checked>
                            </label>
                            <span>Tuesday</span>
                        </div>
                        <ng-template [ngTemplateOutlet]="copyButtons"
                                     [ngTemplateOutletContext]="{currentIndex: 2}"></ng-template>
                        <div class="hourly-range-times"
                             *ngIf="form.value.timeSequenceType && (form.value.timeSequenceType == 'hourly'
                                    || form.value.timeSequenceType == 'range') && checkboxIsChecked('tuesdayCheckbox')">
                            <div *ngIf="weekDays.length && getDayIndexInWeekDaysArray(2) != -1">
                                <div
                                    *ngFor="let dayHour of weekDays[getDayIndexInWeekDaysArray(2)].dayHours; let index = index;"
                                    style="display: inline-flex;">
                                    <ng-template [ngTemplateOutlet]="fromDayColumn"
                                                 [ngTemplateOutletContext]="{dayHour: dayHour}"></ng-template>
                                    <ng-template [ngTemplateOutlet]="toDayColumn"
                                                 [ngTemplateOutletContext]="{dayHour: dayHour}"></ng-template>
                                    <div class="action-block">
                                        <i class="fa fa-plus" (click)="addTimeSlot('tuesday', 2, index)"></i>
                                        <i class="fa fa-trash"
                                           (click)="deleteTimeSlot(2, index)"
                                           *ngIf="weekDays[getDayIndexInWeekDaysArray(2)].dayHours.length > 1"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row bookable-column">
                        <div class="img-checkbox">
                            <input id="wednesdayCheckbox"
                                   type="checkbox"
                                   name="wednesdayCheckbox"
                                   #wednesdayCheckbox
                                   (change)="onDayCheckboxValueChange('wednesdayCheckbox', 3)">
                            <label for="wednesdayCheckbox">
                                <svg-checked></svg-checked>
                            </label>
                            <span>Wednesday</span>
                        </div>
                        <ng-template [ngTemplateOutlet]="copyButtons"
                                     [ngTemplateOutletContext]="{currentIndex: 3}"></ng-template>
                        <div class="hourly-range-times"
                             *ngIf="form.value.timeSequenceType && (form.value.timeSequenceType == 'hourly'
                                    || form.value.timeSequenceType == 'range') && checkboxIsChecked('wednesdayCheckbox')">
                            <div *ngIf="weekDays.length && getDayIndexInWeekDaysArray(3) != -1">
                                <div
                                    *ngFor="let dayHour of weekDays[getDayIndexInWeekDaysArray(3)].dayHours; let index = index;"
                                    style="display: inline-flex;">
                                    <ng-template [ngTemplateOutlet]="fromDayColumn"
                                                 [ngTemplateOutletContext]="{dayHour: dayHour}"></ng-template>
                                    <ng-template [ngTemplateOutlet]="toDayColumn"
                                                 [ngTemplateOutletContext]="{dayHour: dayHour}"></ng-template>
                                    <div class="action-block">
                                        <i class="fa fa-plus" (click)="addTimeSlot('wednesday', 3, index)"></i>
                                        <i class="fa fa-trash"
                                           (click)="deleteTimeSlot(3, index)"
                                           *ngIf="weekDays[getDayIndexInWeekDaysArray(3)].dayHours.length > 1"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row bookable-column">
                        <div class="img-checkbox">
                            <input id="thursdayCheckbox"
                                   type="checkbox"
                                   name="thursdayCheckbox"
                                   #thursdayCheckbox
                                   (change)="onDayCheckboxValueChange('thursdayCheckbox', 4)">
                            <label for="thursdayCheckbox">
                                <svg-checked></svg-checked>
                            </label>
                            <span>Thursday</span>
                        </div>
                        <ng-template [ngTemplateOutlet]="copyButtons"
                                     [ngTemplateOutletContext]="{currentIndex: 4}"></ng-template>
                        <div class="hourly-range-times"
                             *ngIf="form.value.timeSequenceType && (form.value.timeSequenceType == 'hourly'
                                    || form.value.timeSequenceType == 'range') && checkboxIsChecked('thursdayCheckbox')">
                            <div *ngIf="weekDays.length && getDayIndexInWeekDaysArray(4) != -1">
                                <div
                                    *ngFor="let dayHour of weekDays[getDayIndexInWeekDaysArray(4)].dayHours; let index = index;"
                                    style="display: inline-flex;">
                                    <ng-template [ngTemplateOutlet]="fromDayColumn"
                                                 [ngTemplateOutletContext]="{dayHour: dayHour}"></ng-template>
                                    <ng-template [ngTemplateOutlet]="toDayColumn"
                                                 [ngTemplateOutletContext]="{dayHour: dayHour}"></ng-template>
                                    <div class="action-block">
                                        <i class="fa fa-plus" (click)="addTimeSlot('thursday', 4, index)"></i>
                                        <i class="fa fa-trash"
                                           (click)="deleteTimeSlot(4, index)"
                                           *ngIf="weekDays[getDayIndexInWeekDaysArray(4)].dayHours.length > 1"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row bookable-column">
                        <div class="img-checkbox">
                            <input id="fridayCheckbox"
                                   type="checkbox"
                                   name="fridayCheckbox"
                                   #fridayCheckbox
                                   (change)="onDayCheckboxValueChange('fridayCheckbox', 5)">
                            <label for="fridayCheckbox">
                                <svg-checked></svg-checked>
                            </label>
                            <span>Friday</span>
                        </div>
                        <ng-template [ngTemplateOutlet]="copyButtons"
                                     [ngTemplateOutletContext]="{currentIndex: 5}"></ng-template>
                        <div class="hourly-range-times"
                             *ngIf="form.value.timeSequenceType && (form.value.timeSequenceType == 'hourly'
                                    || form.value.timeSequenceType == 'range') && checkboxIsChecked('fridayCheckbox')">
                            <div *ngIf="weekDays.length && getDayIndexInWeekDaysArray(5) != -1">
                                <div
                                    *ngFor="let dayHour of weekDays[getDayIndexInWeekDaysArray(5)].dayHours; let index = index;"
                                    style="display: inline-flex;">
                                    <ng-template [ngTemplateOutlet]="fromDayColumn"
                                                 [ngTemplateOutletContext]="{dayHour: dayHour}"></ng-template>
                                    <ng-template [ngTemplateOutlet]="toDayColumn"
                                                 [ngTemplateOutletContext]="{dayHour: dayHour}"></ng-template>
                                    <div class="action-block">
                                        <i class="fa fa-plus" (click)="addTimeSlot('friday', 5, index)"></i>
                                        <i class="fa fa-trash"
                                           (click)="deleteTimeSlot(5, index)"
                                           *ngIf="weekDays[getDayIndexInWeekDaysArray(5)].dayHours.length > 1"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row bookable-column">
                        <div class="img-checkbox">
                            <input id="saturdayCheckbox"
                                   type="checkbox"
                                   name="saturdayCheckbox"
                                   #saturdayCheckbox
                                   (change)="onDayCheckboxValueChange('saturdayCheckbox', 6)">
                            <label for="saturdayCheckbox">
                                <svg-checked></svg-checked>
                            </label>
                            <span>Saturday</span>
                        </div>
                        <ng-template [ngTemplateOutlet]="copyButtons"
                                     [ngTemplateOutletContext]="{currentIndex: 6}"></ng-template>
                        <div class="hourly-range-times"
                             *ngIf="form.value.timeSequenceType && (form.value.timeSequenceType == 'hourly'
                                    || form.value.timeSequenceType == 'range') && checkboxIsChecked('saturdayCheckbox')">
                            <div *ngIf="weekDays.length && getDayIndexInWeekDaysArray(6) != -1">
                                <div
                                    *ngFor="let dayHour of weekDays[getDayIndexInWeekDaysArray(6)].dayHours; let index = index;"
                                    style="display: inline-flex;">
                                    <ng-template [ngTemplateOutlet]="fromDayColumn"
                                                 [ngTemplateOutletContext]="{dayHour: dayHour}"></ng-template>
                                    <ng-template [ngTemplateOutlet]="toDayColumn"
                                                 [ngTemplateOutletContext]="{dayHour: dayHour}"></ng-template>
                                    <div class="action-block">
                                        <i class="fa fa-plus" (click)="addTimeSlot('saturday', 6, index)"></i>
                                        <i class="fa fa-trash"
                                           (click)="deleteTimeSlot(6, index)"
                                           *ngIf="weekDays[getDayIndexInWeekDaysArray(6)].dayHours.length > 1"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row bookable-column">
                        <div class="img-checkbox">
                            <input id="sundayCheckbox"
                                   type="checkbox"
                                   name="sundayCheckbox"
                                   #sundayCheckbox
                                   (change)="onDayCheckboxValueChange('sundayCheckbox', 7)">
                            <label for="sundayCheckbox">
                                <svg-checked></svg-checked>
                            </label>
                            <span>Sunday</span>
                        </div>
                        <ng-template [ngTemplateOutlet]="copyButtons"
                                     [ngTemplateOutletContext]="{currentIndex: 7}"></ng-template>
                        <div class="hourly-range-times"
                             *ngIf="form.value.timeSequenceType && (form.value.timeSequenceType == 'hourly'
                                    || form.value.timeSequenceType == 'range') && checkboxIsChecked('sundayCheckbox')">
                            <div *ngIf="weekDays.length && getDayIndexInWeekDaysArray(7) != -1">
                                <div
                                    *ngFor="let dayHour of weekDays[getDayIndexInWeekDaysArray(7)].dayHours; let index = index;"
                                    style="display: inline-flex;">
                                    <ng-template [ngTemplateOutlet]="fromDayColumn"
                                                 [ngTemplateOutletContext]="{dayHour: dayHour}"></ng-template>
                                    <ng-template [ngTemplateOutlet]="toDayColumn"
                                                 [ngTemplateOutletContext]="{dayHour: dayHour}"></ng-template>
                                    <div class="action-block">
                                        <i class="fa fa-plus" (click)="addTimeSlot('sunday', 7, index)"></i>
                                        <i class="fa fa-trash" (click)="deleteTimeSlot(7, index)"
                                           *ngIf="weekDays[getDayIndexInWeekDaysArray(7)].dayHours.length > 1"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>


<ng-template #fromDayColumn
             let-dayHour="dayHour"
>
    <div class="from-to-day-columns">
        <div class="from-to-hours">
            <select class="form-control"
                    [(ngModel)]="dayHour.minHour.hour"
                    (change)="dayHour.minHour.minutes = dayHour.minHour.minutes ? dayHour.minHour.minutes : '00'">
                <option value="" hidden></option>
                <option *ngFor="let hour of hoursArray" [value]="hour">
                    {{hour}}
                </option>
            </select>
            <select class="form-control" [(ngModel)]="dayHour.minHour.minutes">
                <option value="" hidden></option>
                <option *ngFor="let minutes of minutesArray" [value]="minutes">
                    {{minutes}}
                </option>
            </select>
        </div>
        <div class="from-to-am-pm">
            <select class="form-control" [(ngModel)]="dayHour.minHour.amPM">
                <option value="" hidden></option>
                <option [value]="'AM'">AM</option>
                <option [value]="'PM'">PM</option>
            </select>
        </div>
    </div>
</ng-template>

<ng-template #toDayColumn
             let-dayHour="dayHour"
>
    <div class="from-to-day-columns">
        <div class="from-to-hours">
            <select class="form-control"
                    [(ngModel)]="dayHour.maxHour.hour"
                    (change)="dayHour.maxHour.minutes = dayHour.maxHour.minutes ? dayHour.maxHour.minutes : '00'">
                <option value="" hidden></option>
                <option *ngFor="let hour of hoursArray" [value]="hour">
                    {{hour}}
                </option>
            </select>
            <select class="form-control" [(ngModel)]="dayHour.maxHour.minutes">
                <option value="" hidden></option>
                <option *ngFor="let minutes of minutesArray" [value]="minutes">
                    {{minutes}}
                </option>
            </select>
        </div>
        <div class="from-to-am-pm">
            <select class="form-control" [(ngModel)]="dayHour.maxHour.amPM">
                <option value="" hidden></option>
                <option [value]="'AM'">AM</option>
                <option [value]="'PM'">PM</option>
            </select>
        </div>
    </div>
</ng-template>

<ng-template #copyButtons let-currentIndex="currentIndex">
    <div style="width: 12px;">
        <ng-container *ngIf="currentIndex !== 1">
            <i
                [ngStyle]="{'opacity' : (form.value.timeSequenceType == 'hourly' || form.value.timeSequenceType == 'range') ? '1' : '0'}"
                title="Copy schedule to the previous available day"
                class="fa fa-arrow-circle-up m-t-xs"
                aria-hidden="true"
                (click)="copyScheduleToDay(currentIndex, currentIndex - 1, false)"
                style="opacity: 0;">
            </i>
        </ng-container>
        <ng-container *ngIf="currentIndex !== 7">
            <i [ngStyle]="{'opacity' : (form.value.timeSequenceType == 'hourly' || form.value.timeSequenceType == 'range') ? '1' : '0'}"
               title="Copy schedule to the next available day"
               class="fa fa-arrow-circle-down m-t-xs"
               aria-hidden="true"
               (click)="copyScheduleToDay(currentIndex, currentIndex + 1, true)"></i>
        </ng-container>
    </div>
</ng-template>



// WEBPACK FOOTER //
// /app/src/app/views/settings-amenities/schedule-modal/schedule-modal.component.html